<script>
  export let href = ''
  export let title = undefined
</script>

<a {href} {title}><slot></slot></a>
